import { Colors } from "@/enums/Colors";
import environment from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/environment.json";
import { useToggle } from "@/hooks/useToggle";
import { Box } from "@mui/material";
import LazoTooltip from "./utils/LazoTooltip";

function EnvOverlay() {
  const [hidden, toggleHidden] = useToggle(false);

  return (
    <LazoTooltip title={`Click to ${hidden ? "show" : "hide"}`}>
      <Box
        sx={{
          opacity: hidden ? 0.2 : 0.8,
          position: "fixed",
          width: "100vw",
          pointerEvents: "none",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          zIndex: 100000,
        }}
      >
        <Box
          sx={{
            fontWeight: "bold",
            fontSize: "1rem",
            color: "white",
            padding: "0.25rem 0.6rem",
            borderColor: Colors.AMATIST_PURPLE,
            borderStyle: "solid",
            borderWidth: "0.2rem",
            borderTopWidth: "0",
            backgroundColor: Colors.PURPLE,
            width: "fit-content",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            alignSelf: "center",
            boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.15)",
            userSelect: "none",
            pointerEvents: "all",
            cursor: "pointer",
          }}
          onClick={() => toggleHidden()}
        >
          {`${environment.env.toUpperCase()}`}
        </Box>
      </Box>
    </LazoTooltip>
  );
}

export default EnvOverlay;
